import * as STD                            from '@emersya/mpa-std-lib';

import CM                                  from '@emersya/mpa-components-manager-lib';
import { Block, InputBool }                from '@emersya/mpa-components-lib';
import ViewerComponent, { NS as ViewerNS } from '../../../viewer/Viewer/Viewer';
// import * as Emersya                        from '@libs/MPAApplication/index';
// import * as PlannerNS                      from '../../../viewer/planner/Planner/ViewerPlanner';

export interface IStandingBannerComponentConfiguration extends Block.Configuration {
	text : STD.translationsManager.TranslationMapping;
	forceBackgroundColor? : string | null;
	textGraphic : STD.translationsManager.TranslationMapping;
};

export class StandingBannerComponent extends Block.Component {
	static override initialize() {
		super.initialize();
	};

	readonly plannerCategory! : ViewerComponent.ProductCategory;
	viewerNode : ViewerComponent.ProductInstance | null = null;
	firstInstance : boolean = true;

	getWDH() {
		const p = app.currentProduct;
		if (!p) {
			this.component_throwUserError('');
		}
		const dpart = p.getPart([ 'dimensions' ]);
		return {
			width :  Number.parseFloat(dpart.getPart([ 'width' ])?.reference?.value || <string> <any> 1),
			depth :  Number.parseFloat(dpart.getPart([ 'depth' ])?.reference?.value || <string> <any> 1),
			height : Number.parseFloat(dpart.getPart([ 'height' ])?.reference?.value || <string> <any> 1)
		};
	};

	async reset() {
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		if (!app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		if (this.viewerNode) {
			await this.viewerNode.delete();
			this.viewerNode = null;
		}
		const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
		if (!inputBool) {
			throw STD.errors.user('Missing input bool in content');
		}
		if (inputBool.value) {
			await inputBool.updateValue(false);
		}
		const bannerPart = app.basket.basket.currentProduct.parts.find(x => x.id === 'banner');
		if (bannerPart) {
			await app.basket.basket.currentProduct.getPart([ 'banner' ]).remove();
		}
	};

	async remove(){
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		if (!app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		if (this.viewerNode) {
			await this.viewerNode.delete();
			this.viewerNode = null;
		}
		const bannerPart = app.basket.basket.currentProduct.parts.find(x => x.id === 'banner');
		if (bannerPart) {
			await app.basket.basket.currentProduct.getPart([ 'banner' ]).remove();
		}
	};

	async onProductChange_before(){
		await this.remove();
		this.firstInstance = true;
	};

	private computeMatrix() {
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available in arch!');
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No part layout available in arch');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			throw STD.errors.user('No current option in layout part in arch');
		}
		const layoutId = layoutCurrentOption.id;
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		if (!app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		const wdh = this.getWDH();
		const x = wdh.width;
		const y = wdh.height;
		const z = wdh.depth;
		const banner = app.component_configuration.productsComponents.find(x => x.type === 'banner');
		if (!banner) {
			throw STD.errors.user('No banner found');
		}
		const boundingBoxBanner = banner.boundingBox;
		if (!boundingBoxBanner) {
			throw STD.errors.user('Missing bounding box for banner ');
		}
		if (layoutId === 'shape-no-wall') {
			return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
		} else if (layoutId === 'shape-back-left') {
			return (ViewerNS.Component.mtx(
				[ -x / 2, y - boundingBoxBanner.height, z / 2 - boundingBoxBanner.width / 2 ],
				[ 1, 1, 1 ],
				90
			));
		} else if (layoutId === 'shape-back') {
			return (ViewerNS.Component.mtx(
				[ x / 2 - boundingBoxBanner.width / 2, y - boundingBoxBanner.height, -z / 2 ],
				[ 1, 1, 1 ],
				0
			));
		} else if (layoutId === 'shape-back-right') {
			return (ViewerNS.Component.mtx(
				[ x / 2, y - boundingBoxBanner.height, z / 2 - boundingBoxBanner.width / 2 ],
				[ 1, 1, 1 ],
				270
			));
		} else if (layoutId === 'shape-left-back-right') {
			return (ViewerNS.Component.mtx(
				[ x / 2, y - boundingBoxBanner.height, z / 2 - boundingBoxBanner.width / 2 ],
				[ 1, 1, 1 ],
				270
			));
		} else {
			throw STD.errors.user('Unknown layout id in banner');
		}
	}

	async updateWithoutReset(){
		await app.viewer.freezeRendering({ keepCount : true });
		if (app.isReloading) {
			if (!this.viewerNode) {
				await this.insert();
			}
		} else {
			if (this.viewerNode) {
				await this.remove();
			}
			await this.insert();
		}
		await app.viewer.unfreezeRendering({ keepCount : true });
	}

	async update() {
		const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
		if(!inputBool){
			this.component_throwUserError('');
		}
		if(!inputBool.value && this.firstInstance){
			inputBool.updateValue(true);
		}else if(!inputBool.value){
			return;
		}
		this.firstInstance = false;
		await app.viewer.freezeRendering({ keepCount : true });
		if (app.isReloading) {
			if (!this.viewerNode) {
				await this.insert();
			}
		} else {
			if (this.viewerNode) {
				await this.reset();
			}
			await this.insert();
		}
		await app.viewer.unfreezeRendering({ keepCount : true });
	};

	async insert() {
		// insert nodes
		const product = app.currentProduct;
		if (this.viewerNode || !product || !app.viewer.planner) {
			this.component_throwUserError('');
		}
		if (product.id === 'confort' || product.id === 'siae' || product.id === 'business') {
			return;
		}
		const part = product.createPart({
			id :        'banner',
			title :     'Banner',
			reference : null,
			metaData :  null,
			parts :     [],
			options :   []
		});
		await part.initialize();
		const category = app.viewer.categories.find(x => x.name === 'banner');
		if (!category) {
			this.component_throwLibraryError('');
		}
		if (app.isReloading) {
			const instances = Array.from(app.viewer.safe.value.productInstances);
			const node = instances.find(x => x.product.category === category);
			if (!node) {
				return;
			}
			this.viewerNode = node;
			await (<ViewerGraphicsNS.Component> this.component_find('@:graphic')).updateValue((<any> node).metadata.customImages[ 0 ]);
			this.viewerNode.setName('banner');
			return;
		}
		const bannerProductSchema = this.plannerCategory.products.find(x => x.SKU === '@banner');
		if (!bannerProductSchema) {
			this.component_throwLibraryError('');
		}
		const personalizationPart = app.currentProduct.parts.find( x => x.id === 'personalization')?.currentOption;
		if(!personalizationPart){
			this.viewerNode = await bannerProductSchema.instantiate({
				rootLocalId : app.viewer.globalLocalId,
				appendType : 'insert',
				basketPart  : [],
				basketUseDynamicTitleBinding : true,
				metadata : {
					id : this.id,
					customImages : [
						{
							enabled :   false,
							leftRight : 0,
							upDown :    0,
							resize :    1,
							rotate :    0,
							image :     null
						}
					]
				}
			});
		}else{
			const currentOptionPersonalization = app.component_configuration.productsOptions.find(x => x.SKU === personalizationPart.id);
			if(!currentOptionPersonalization){
				this.component_throwLibraryError('');
			}
			const config = currentOptionPersonalization.viewerGroups;
			if(!config){
				this.component_throwLibraryError('');
			}
			this.viewerNode = await bannerProductSchema.instantiate({
				rootLocalId : app.viewer.globalLocalId,
				appendType : 'insert',
				basketPart  : [],
				basketUseDynamicTitleBinding : true,
				metadata : {
					id : this.id,
					customImages : [
						{
							enabled :   false,
							leftRight : 0,
							upDown :    0,
							resize :    1,
							rotate :    0,
							image :     null
						}
					]
				},
				configuration : {
					'banner' : {
						materialsGroups : config
					}
				}
			});
		}
		this.viewerNode.setName('banner');
		await app.viewer.batch([
			[
				'setProductNodesInstancesMatrices', [
				{
					localId : this.viewerNode.localId,
					matrix :  this.computeMatrix()
				}
			]
			]
		]);
		const ciData = this.viewerNode?.metadata?.customImages?.[ 0 ];
		if (ciData) {
			await (<ViewerGraphicsNS.Component> this.component_find('@:graphic')).updateValue(<any> ciData);
		}
		const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
		if (!inputBool) {
			throw STD.errors.user('Missing input bool in content');
		}
		if (!inputBool.value) {
			await inputBool.updateValue(true);
		}
	};

	async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		// await super.onValueUpdated(ev);
		if (ev.details.isDefaultValue) {
			return;
		}
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		;
		const graphicComponent = <InputBool.Component> this.component_find('@:graphic');
		await app.transaction(async () => {
			if (ev.details.newValue) {
				await graphicComponent.component_enable();
				await this.updateWithoutReset();
			} else {
				const graphicInput = <InputBool.Component> this.component_find('@:graphic:header.enable');
				if (graphicInput.value) {
					await graphicInput.updateValue(false);
				}
				await graphicComponent.component_disable();
				await this.reset();
			}
		});
	};

	override async component_initialize() {
		await this.component_find('@:field:content').component_instantiateOuterChild({
			type :          'input-bool',
			isSlot :        false,
			declaredSlot :  null,
			id :            'options',
			slot :          null,
			tree :          this.component_tree,
			parentNode :    null,
			configuration : <InputBool.Configuration> {
				type :            'yesno',
				defaultValue :    true,
				'@translations' : {
					checked :   {
						'en' : 'Yes',
						'fr' : 'Oui'
					},
					unchecked : {
						'en' : 'No',
						'fr' : 'Non'
					}
				}
			}
		});
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		const categoryDescriptor : ViewerComponent.ProductCategory.IDescriptor & {
			products : NonNullable<ViewerComponent.ProductCategory.IDescriptor['products']>;
		} = {
			name :        'banner',
			menuActions : {
				edit :      true,
				delete :    false,
				rotate :    false,
				duplicate : false
			},
			products :    []
		};
		if (app.component_configuration.products.find(x => x.SKU === 'prestige')) {
			const bannerComponent = app.component_configuration.productsComponents.find(x => x.type === 'banner');
			if (!bannerComponent) {
				throw STD.errors.user('Missing banner component');
			}
			app.viewer.productsExtensionById[ '@banner' ] = {
				quantity :     null,
				customImages : [
					{
						id :                'customImage',
						title :             { en : 'Add logo', fr : 'Ajouter un logo' },
						width :             1,
						height :            2.35,
						mesh :              'SIGNALITIQUE_MURALE_CUSTOM',
						material :          {
							name :          'custom_signalitique_murale',
							configuration : {
								enabled :  'custom_signalitique_murale',
								disabled : 'off'
							}
						},
						pricingInfo :       null,
						volumeComputation : null
					}
				]
			};
			categoryDescriptor.products.push({
				SKU :   '@banner',
				nodes : [
					{
						SKU :                         <string> bannerComponent.viewerComponentSKU,
						projectCode :                 <string> bannerComponent.viewerProjectCode,
						localId :                     'banner',
						parentLocalId :               'root',
						snappable :                   false,
						fixedPositionSetIds :         null,
						draggable :                   false,
						doNotListAsProductComponent : true,
						tracked : 					  true,
						matrix :                      app.viewer.mtx(
							[ 0, 0, 0 ],
							[ 0, 0, 0 ],
							0
						)
					}
				]
			});
		}
		(<any> this).plannerCategory = app.viewer.createCategory(categoryDescriptor);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingBannerComponentConfiguration
	)
	{
		configuration[ '@innerConfigurations' ] = {
			field : {
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							label : {
								'@translations' : {
									text : configuration.text
								}
							}
						}
					}
				}
			},
			graphic :    <Partial<ViewerGraphicsNS.Configuration>> {
				forceBackgroundColor :   configuration.forceBackgroundColor,
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							title : {
								'@translations' : {
									text : configuration.textGraphic
								}
							}
						}
					}
				}
			}
		};
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});

	};
};
export namespace NS {
	export const Component = StandingBannerComponent;
	export type Component = StandingBannerComponent;
	export type Configuration = IStandingBannerComponentConfiguration;
}
import manifestXMLSource                   from './StandingBanner.xml';
import './StandingBanner.scss';
import { NS as ViewerGraphicsNS }        from '../../../viewer/Graphics/ViewerGraphics';

CM.declare({
	id :       'standing-banner',
	type :     StandingBannerComponent,
	manifest : manifestXMLSource
});
